import React, { useState, useEffect } from "react";
import * as httpClient from "../../util/httpClient";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../store";
import * as PasswordManagerUtil from "../IdentityVault/PasswordManager/passwordManagerUtil";
import * as Common from "../../util/common";
import i18nService from "../../util/Internationalization/i18n/i18n";
import { months } from "../../util/CommonLists";
import RenderIcons from "../../Assets/css/_icons/partner_icon/RenderIcons";
import { useTranslation } from "react-i18next";

const ViewPassword = (props: any) => {
    const [passwordData, setPasswordData] = useState({
        websiteName: "",
        favorite: null,
        websiteUsername: "",
        websiteUrl: "",
        lastUpdateDate: "",
        websitePassword: "",
        notes: "",
    });

    const [hiddenPassword, setHiddenPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [passwordShown, setPasswordShown] = useState(false);
    const [strength, setPasswordStrength] = useState({ score: 0, message: "", color: "gray" });
    const passwordRecordExtId = useSelector((state: ApplicationState) => state.passwordManagerState && state.passwordManagerState.selectedPasswordRecordExtId);
    const { t: tLang } = useTranslation();

    useEffect(() => {
        getPasswordData();
    }, [passwordRecordExtId]);

    const isValidUrl = (string: string) => {
        try {
            new URL(string);
        } catch (_) {
            return false;
        }

        return true;
    };

    const getPasswordData = () => {
        setLoading(true);
        const requestBody = {
            RecordExtId: passwordRecordExtId,
        };

        if (passwordRecordExtId != "") {
            httpClient
                .sendRequest("POST", `api/securepassword/getPasswordById`, requestBody)
                .then((data) => {
                    if (data.isSuccess) {
                        const decodedData = Common.decodeData(Common.decodeData(data));

                        setPasswordData({
                            websiteName: decodedData["websiteName"],
                            favorite: data["favorite"],
                            websiteUsername: decodedData["websiteUsername"],
                            websiteUrl: decodedData["websiteUrl"],
                            lastUpdateDate: data["lastUpdateDate"],
                            websitePassword: data["websitePassword"],
                            notes: decodedData["notes"],
                        });
                        updatePasswordStrength(data["websitePassword"]);
                        updateHiddenPassword(data["websitePassword"]);
                    }

                    setLoading(false);
                })
                .catch(function (error) {
                    setLoading(false);
                });
        }
    };

    const updateHiddenPassword = (password: string) => {
        let hPassword = "";
        for (let i = 0; i < password.length; i++) {
            hPassword += "*";
        }
        setHiddenPassword(hPassword);
    };

    const updatePasswordStrength = (password: string) => {
        const strength = PasswordManagerUtil.passwordManagerUtilFunctions.getPasswordStrength(password, tLang);
        setPasswordStrength(strength);
    };

    const closeDialog = () => {
        document.body.classList.remove("no_scroll");
        props.closeDialog();
    };

    const openEditPasswordPopup = () => {
        window.addToDataLayer({ event: "Edit Password" });
        closeDialog();
        props.showEditPasswordDialog();
    };

    useEffect(() => {
        window.addEventListener("keyup", (evt: any) => {
            evt = evt || window.event;
            var isEscape = false;
            if ("key" in evt) {
                isEscape = evt.key === "Escape" || evt.key === "Esc";
            } else {
                isEscape = evt.keyCode === 27;
            }
            if (isEscape) {
                closeDialog();
            }
        });
        return () => {
            window.removeEventListener("keyup", () => {});
        };
    });
    const countryWiseDateFormatting = (date: any) => {
        if (!Boolean(date)) {
            return "";
        }
        const month = months[Number(date.split("/")[0]) - 1];
        const day = date.split("/")[1];
        const year = date.split("/")[2];
        const time = date.split("/")[2].split(" ");
        if (i18nService.get("Country") === "US") {
            return `${month} ${day} ${year}`;
        } else if (i18nService.get("Country") === "CA" || i18nService.get("Country") === "TW") {
            return `${time[0]} ${month} ${day} ${time[1]} ${time[2]}`;
        } else {
            return `${day} ${month} ${year}`;
        }
    };

    return (
        <React.Fragment>
            <div className="dialog-header">
                <div className="dialog-icon">
                    <RenderIcons iconName="key" />
                </div>
                <h1 style={{ overflowWrap: "break-word" }}>
                    <span className="sr-only">Password details for</span>
                    {" " + passwordData.websiteName + " "}
                    {passwordData.favorite && (
                        <span className="color-yellow">
                            <em className="las la-star"></em>
                            <span className="sr-only">Marked as favorite</span>
                        </span>
                    )}
                </h1>
            </div>
            <div className={loading ? "dialog-body loading" : "dialog-body"}>
                <div role="grid" className="data-grid row-height-sm" id="password-detaila" aria-hidden="false">
                    <div role="row" className="data-row row">
                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                            <div role="gridcell" className="data-label" id="vp-label-username-email">
                                {tLang("identityVault.passwordManager.addEditPassword.copyUNEmailToolTip")}
                            </div>
                        </div>
                        <div className="col-xs-12 col-sm-8 col-no-gutter">
                            {passwordData.websiteUsername && (
                                <div className="row">
                                    <div className="col-xs-10 col-no-gutter">
                                        <div role="gridcell" className="data-value" aria-labelledby="vp-label-username-email">
                                            {Common.getUserNameOrMaskedEmail(passwordData.websiteUsername)}
                                        </div>
                                    </div>
                                    <div role="gridcell" className="col-xs-2 flex-grow-null col-no-gutter text-align-right">
                                        <button
                                            className="btn-default btn-link btn-no-border btn-icon-only btn-no-padding"
                                            title={tLang("identityVault.passwordManager.addEditPassword.copyUNEmailToolTip")}
                                            onClick={(event: any) => {
                                                navigator.clipboard.writeText(passwordData.websiteUsername);
                                                window.showTooltip(event.target);
                                                window.addToDataLayer({ event: "Copy Username / Email" });
                                            }}
                                            id="copyUsername"
                                        >
                                            <span className="btn-icon">
                                                <em className="las la-copy"></em>
                                            </span>
                                            <span className="btn-text">
                                                Copy <span className="sr-only">Username / Email</span>
                                            </span>
                                            <span className="btn-tooltip" style={{ display: "none" }}>
                                                Copied
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                    <div role="row" className="data-row row">
                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                            <div role="gridcell" className="data-label" id="vp-label-password">
                                {tLang("identityVault.passwordManager.addEditPassword.label.password")}
                            </div>
                        </div>
                        <div className="col-xs-12 col-sm-8 col-no-gutter">
                            <div className="row">
                                <div className="col-xs-9 col-no-gutter">
                                    <div role="gridcell" className="data-value" aria-labelledby="vp-label-password">
                                        {passwordShown && <span id="password-value">{passwordData.websitePassword}</span>}
                                        {!passwordShown && <span id="password-value">{hiddenPassword}</span>}
                                    </div>
                                </div>
                                <div role="gridcell" className="col-xs-3 flex-grow-null col-no-gutter text-align-right">
                                    <ul className="list-reset list-inline">
                                        <li>
                                            <button
                                                className="btn-default btn-link btn-no-border btn-icon-only btn-no-padding"
                                                onClick={() => {
                                                    setPasswordShown(!passwordShown);
                                                    window.addToDataLayer({ event: "Show / Hide Password Text" });
                                                }}
                                                title={
                                                    passwordShown
                                                        ? tLang("identityVault.passwordManager.addEditPassword.hidePwdAddPwdPopUp")
                                                        : tLang("identityVault.passwordManager.addEditPassword.shwPwdAddPwdPopUp")
                                                }
                                            >
                                                <span className="btn-icon">
                                                    <em
                                                        className={`las ${passwordShown ? "la-eye-slash" : "la-eye"
                                                            }`}
                                                    ></em>
                                                </span>
                                                <span className="btn-text">{tLang("identityVault.passwordManager.addEditPassword.showPassword")}</span>
                                            </button>
                                        </li>
                                        <li>
                                            <button
                                                className="btn-default btn-link btn-no-border btn-icon-only btn-no-padding"
                                                title={tLang("identityVault.passwordManager.addEditPassword.copyPassword")}
                                                onClick={(event: any) => {
                                                    navigator.clipboard.writeText(passwordData.websitePassword);
                                                    window.showTooltip(event.target);
                                                    window.addToDataLayer({ event: "Copy Password" });
                                                }}
                                                id="copyPW"
                                            >
                                                <span className="btn-icon">
                                                    <em className="las la-copy"></em>
                                                </span>
                                                <span className="btn-text">
                                                    Copy <span className="sr-only">Password</span>
                                                </span>
                                                <span className="btn-tooltip" style={{ display: "none" }}>
                                                    Copied
                                                </span>
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div role="row" className="data-row row">
                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                            <div role="gridcell" className="data-label" id="vp-label-pw-strength">
                                {tLang("identityVault.passwordManager.addEditPassword.label.strength")}
                            </div>
                        </div>
                        <div className="col-xs-12 col-sm-8 col-no-gutter">
                            <div role="gridcell" className="data-value no-padding" aria-labelledby="vp-label-pw-strength">
                                <span id="vp-passwordmeter" className="passwordmeter">
                                    <span style={{ width: (strength.score + 1) * 25 + "px", backgroundColor: strength.color }}></span>
                                </span>
                                <span id="vp-passwordmessage" className="passwordmessage">
                                    <strong>{strength.message}</strong>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div role="row" className="data-row row">
                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                            <div role="gridcell" className="data-label" id="vp-label-password-last-updated">
                                {tLang("identityVault.passwordManager.addEditPassword.label.passwordLastUpdated")}
                            </div>
                        </div>
                        <div className="col-xs-12 col-sm-8 col-no-gutter">
                            <div role="gridcell" className="data-value" aria-labelledby="vp-label-password-last-updated">
                                {countryWiseDateFormatting(passwordData.lastUpdateDate)}
                            </div>
                        </div>
                    </div>
                    <div role="row" className="data-row row">
                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                            <div role="gridcell" className="data-label" id="vp-label-website-url">
                                {tLang("identityVault.passwordManager.addEditPassword.label.website")}
                            </div>
                        </div>
                        <div className="col-xs-12 col-sm-8 col-no-gutter">
                            {passwordData.websiteUrl && (
                                <div className="row">
                                    <div className="col-xs-10 col-no-gutter">
                                        <div role="gridcell" className="data-value" aria-labelledby="vp-label-website-url">
                                            {passwordData.websiteUrl}
                                        </div>
                                    </div>
                                    <div role="gridcell" className="col-xs-2 flex-grow-null col-no-gutter text-align-right">
                                        <button
                                            className="btn-default btn-link btn-icon-only btn-no-border btn-no-padding"
                                            onClick={() => {
                                                if (isValidUrl(passwordData.websiteUrl)) {
                                                    window.open(passwordData.websiteUrl, "_blank");
                                                    window.addToDataLayer({ event: "Open Website in New Tab" });
                                                }
                                            }}
                                            title={tLang("identityVault.passwordManager.addEditPassword.label.openWebsite")}
                                        >
                                            <span className="btn-icon">
                                                <em className="las la-external-link-alt"></em>
                                            </span>
                                            <span className="btn-text">{tLang("identityVault.passwordManager.addEditPassword.label.openWebsite")}</span>
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                    <div role="row" className="data-row row">
                        <div  className="col-xs-12 col-sm-4 col-no-gutter">
                            <div role="gridcell" className="data-label" id="vp-label-notes">
                                {tLang("identityVault.passwordManager.addEditPassword.label.notes")}
                            </div>
                        </div>
                        <div className="col-xs-12 col-sm-8 col-no-gutter">
                            <div role="gridcell" className="data-value"  aria-labelledby="vp-label-notes">
                                {passwordData.notes ? passwordData.notes : " "}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="dialog-footer">
                <div className="row between-xs">
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <button
                            type="button"
                            className="btn-default btn-secondary"
                            onClick={() => {
                                closeDialog();
                                window.addToDataLayer({ event: "Close View Password" });
                            }}
                        >
                            <span className="btn-text">{tLang("identityVault.passwordManager.addEditPassword.closeButtonText")}</span>
                        </button>
                    </div>
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <button
                            type="button"
                            className="btn-default btn-primary-outline"
                            data-a11y-dialog-show="dialog-edit-password"
                            onClick={openEditPasswordPopup}
                        >
                            <span className="btn-text">{tLang("identityVault.passwordManager.addEditPassword.editButtonText")}</span>
                        </button>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default ViewPassword;
